import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { useApp } from '../contexts/AppContext';
import ProductCard from '../components/products/ProductCard';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Wishlist = () => {
  const { wishlist, fetchWishlist } = useApp();
  const [wishlistProducts, setWishlistProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchWishlist(); }, []);

  useEffect(() => {
    const fetch = async () => {
      if (wishlist.product_ids.length === 0) { setWishlistProducts([]); setLoading(false); return; }
      try {
        setLoading(true);
        const responses = await Promise.all(wishlist.product_ids.map(id => axios.get(`${API}/products/${id}`)));
        setWishlistProducts(responses.map(res => res.data));
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    fetch();
  }, [wishlist.product_ids]);

  if (loading) return (
    <div className="min-h-screen bg-[#FEFCF9] flex items-center justify-center">
      <div className="inline-block w-10 h-10 border-2 border-[#E8DCC8] border-t-[#C4A265] rounded-full animate-spin"></div>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#FEFCF9] py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-serif text-[#3E2723] mb-2">My Wishlist</h1>
        <div className="w-12 h-px bg-[#C4A265] mb-8"></div>

        {wishlistProducts.length === 0 ? (
          <div className="bg-[#FEFCF9] border border-[#E8DCC8] p-12 text-center">
            <Heart className="w-16 h-16 text-[#E8DCC8] mx-auto mb-4" />
            <h2 className="text-2xl font-serif text-[#3E2723] mb-2">Your wishlist is empty</h2>
            <p className="text-[#7A6B5D] mb-6">Save your favorite items to your wishlist</p>
            <Link to="/shop" className="inline-block bg-[#3E2723] text-[#FEFCF9] px-8 py-3 font-semibold hover:bg-[#C4A265] transition-colors tracking-wider uppercase text-sm">Explore Products</Link>
          </div>
        ) : (
          <>
            <p className="text-[#7A6B5D] mb-6">{wishlistProducts.length} {wishlistProducts.length === 1 ? 'item' : 'items'} in your wishlist</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
              {wishlistProducts.map(product => <ProductCard key={product.id} product={product} />)}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Wishlist;
